import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { NetworkStatus } from '@cbridge-utils/network';
import { userSettingsStoreSelector } from '../userSettings.selector';

/**
 * True once the settings are resolved (seeded from the /token response or fetched via
 * the fallback GET). A failed fallback also counts as ready — the app must not stay
 * blocked behind the gate because of a settings error.
 */
export const isUserSettingsReadySelector = createCachedSelector(
  [path(userSettingsStoreSelector).networkStatus()],
  (networkStatus): boolean => networkStatus === NetworkStatus.Done || networkStatus === NetworkStatus.Failed,
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
